import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import dayjs from 'dayjs'
import SelectCompetencia, {
    useCompetencia,
} from 'global/components/Selects/SelectCompetencia'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { SaldoHoras, saldoHoras } from 'service/api'
import { useStore } from 'store'

export default function Implantacao() {
    const empresa = useStore(state => state.company)
    const [competencia, setCompetencia] = useCompetencia()
    const { data, isLoading } = saldoHoras.useFetch({
        queryParams: {
            empresaId: empresa?.id,
            competencia,
            implantacao: true,
        },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header
                    label={[
                        'Manutenção do ponto',
                        'Implantação do banco de horas',
                    ]}
                >
                    <ContentGuide.Filtros SelectEmpresas>
                        <SelectCompetencia
                            onChange={setCompetencia}
                            value={competencia}
                        />
                    </ContentGuide.Filtros>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    onAdd
                    columns={[
                        {
                            field: 'nome',
                            headerName: 'Funcionário',
                            flex: 1,
                            valueGetter: params => params.row.Funcionario.nome,
                        },
                        {
                            field: 'competencia',
                            headerName: 'Competência',
                            width: 220,
                            valueFormatter: params =>
                                dayjs(`${params.value}-01`).format(
                                    'MM/YYYY (MMMM)',
                                ),
                        },
                        {
                            field: 'horasExtras',
                            headerName: 'Horas',
                            width: 80,
                        },
                        {
                            field: 'faltas',
                            headerName: 'Faltas',
                            width: 80,
                        },
                        {
                            field: 'createdAt',
                            headerName: 'Data da implantação',
                            width: 180,
                            type: 'datetime-local',
                            valueFormatter: ({ value }) =>
                                dayjs(value).format('DD/MM/YYYY HH:mm'),
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['delete', 'ImplantaçãoDoBancoDeHoras'],
                                    () => (
                                        <IconButton
                                            title="Excluir"
                                            href={`${id}/excluir`}
                                        >
                                            <Trash2Icon className="text-red-500" />
                                        </IconButton>
                                    ),
                                ),
                        },
                    ]}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-implantacao',
                        },
                    }}
                    rows={data?.filter(item => item.implantacao === 'S')}
                />
            </ContentGuide.Card>
            <Outlet context={{ data, competencia }} />
        </ContentGuide>
    )
}

export function useImplantacaoOutletContext() {
    return useOutletContext<{
        data?: SaldoHoras[]
        competencia: string
    }>()
}
